import { genreOptions, regionOptions, yearOptions } from "@/mocks/filters";

export interface FilterState {
  genres: string[];
  regions: string[];
  years: number[];
}

interface FilterPanelProps {
  value: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
}

function Group({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-4 last:border-0 md:flex-row md:items-start md:gap-4">
      <h4 className="shrink-0 pt-1 font-heading text-sm font-semibold text-foreground-800 md:w-16">{title}</h4>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

const chipClass = (active: boolean) =>
  `cursor-pointer whitespace-nowrap rounded-md border px-3 py-1.5 text-sm transition-colors ${
    active
      ? "border-accent-500 bg-accent-500 text-white"
      : "border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-700"
  }`;

export default function FilterPanel({ value, onChange, onReset }: FilterPanelProps) {
  const toggle = <T,>(arr: T[], item: T): T[] =>
    arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];

  return (
    <div className="rounded-xl border border-background-200 bg-background-50 px-4 md:px-5">
      <div className="flex items-center justify-between border-b border-background-200 py-3">
        <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-accent-600" /> 筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="flex cursor-pointer items-center gap-1 text-xs text-foreground-500 transition-colors hover:text-accent-600"
        >
          <i className="ri-refresh-line" /> 重置筛选
        </button>
      </div>

      <Group title="类型">
        {genreOptions.map((g) => (
          <button
            key={g}
            type="button"
            onClick={() => onChange({ ...value, genres: toggle(value.genres, g) })}
            className={chipClass(value.genres.includes(g))}
          >
            {g}
          </button>
        ))}
      </Group>

      <Group title="地区">
        {regionOptions.map((r) => (
          <button
            key={r}
            type="button"
            onClick={() => onChange({ ...value, regions: toggle(value.regions, r) })}
            className={chipClass(value.regions.includes(r))}
          >
            {r}
          </button>
        ))}
      </Group>

      <Group title="年份">
        {yearOptions.map((y) => (
          <button
            key={y}
            type="button"
            onClick={() => onChange({ ...value, years: toggle(value.years, y) })}
            className={chipClass(value.years.includes(y))}
          >
            {y}
          </button>
        ))}
      </Group>
    </div>
  );
}